import { ICreateControledePatrimonioInspecaoUseCase } from "../../../presentation/useCases/create/create_controlede_patrimonio_inspecao_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * CreateControledePatrimonioInspecaoUseCase
 */

export class CreateControledePatrimonioInspecaoUseCase implements ICreateControledePatrimonioInspecaoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createControledePatrimonioInspecao(
    idControleCentroCusto: number,
    dataInspecao: Date | null,
    idMaquinaEquip: number,
    codigoMaquinaEquip: string | null,
  ): Promise<number> {
    return await this.repository.createControledePatrimonioInspecao(
      idControleCentroCusto,
      dataInspecao,
      idMaquinaEquip,
      codigoMaquinaEquip,
    );
  }
}
